import { ControlSheetRow } from '../types/types'

export const rowId = (row: ControlSheetRow) => {
    const outbound = row.inbound?.isTakeoverRow
        ? 'null'
        : row.outbound
          ? `${row.outbound.trip}-${row.outbound.duty}-${row.outbound.isTakeoverRow}`
          : 'null'
    const inbound = row.inbound ? `${row.inbound.trip}-${row.inbound.duty}-${row.inbound.isTakeoverRow}` : 'null'
    return `${row.run}-${outbound}-${inbound}`
}
